/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-22 12:21:39
 *
 * LastModified: 2017-05-22 12:21:39
 *-------------------------------------------------------*/

import { fork } from 'redux-saga/effects'

import authFlow from '../routes/auth/saga'
import userFlow from '../routes/app/routes/profile/saga'
import glassesFlow from '../routes/app/routes/glasses-list/saga'
import glassesDetailFlow from '../routes/app/routes/glasses-detail/saga'
import groupGlassesDetailFlow from '../routes/app/routes/glasses-group-detail/saga'
import glassesGroupFlow from '../routes/app/routes/glasses-group/saga'
import storeFlow from '../routes/app/routes/stores/saga'
import paymentFlow from '../routes/app/routes/checkout/saga'
import dashboardFlow from '../routes/app/routes/dashboard/saga'
import brandFlow from '../routes/app/routes/brand/saga'
import shopLocatorFlow from '../routes/app/routes/shop-locator/saga'
import shopLocaleFlow from '../routes/app/routes/shop-locale/saga'
import invoiceFlow from '../routes/app/routes/invoice/saga'
import delegateFlow from '../routes/app/routes/delegate-list/saga'
import adminFlow from '../routes/admin/routes/dashboard/saga'
import { lensListFlow } from '../routes/app/routes/lens-list/saga'

// Admin
import { usersListFlow, userDetailFlow } from '../routes/admin/routes/users/saga'
import { summariesListFlow } from '../routes/admin/routes/summary-list/saga'

export function* startup() {
  if (process.env.NODE_ENV !== 'production') {
    yield console.log('Hello Redux-Saga')
  }
}

export default function* root() {
  // combine your saga here
  yield fork(startup)
  yield fork(authFlow)
  yield fork(userFlow)
  yield fork(usersListFlow)
  yield fork(userDetailFlow)
  yield fork(glassesFlow)
  yield fork(glassesDetailFlow)
  yield fork(groupGlassesDetailFlow)
  yield fork(glassesGroupFlow)
  yield fork(storeFlow)
  yield fork(paymentFlow)
  yield fork(dashboardFlow)
  yield fork(brandFlow)
  yield fork(shopLocatorFlow)
  yield fork(shopLocaleFlow)
  yield fork(invoiceFlow)
  yield fork(delegateFlow)
  yield fork(adminFlow)
  yield fork(summariesListFlow)
  yield fork(lensListFlow)
}



// WEBPACK FOOTER //
// ./sagas/index.js